import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  processes: [],
  processStatus: [],
  processTypes: [],
  departaments: [],
  pendingProcesses: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
